import type { FC } from 'react';
import { memo, useEffect, useRef } from 'react';
import { useClickAway } from 'ahooks';
import { Divider, message } from 'antd';
import ShortcutsName from './shortcuts-name';
import { useStore } from './store';
import {
  useDSL,
  useNodesInteractions,
  usePanelInteractions,
  useNodesReadOnly,
  // useWorkflowStartRun,
} from './hooks';
import AddBlock from './operator/add-block';
import { useOperator } from './operator/hooks';
import cn from '@/utils/classnames';
type PanelContextMenuProps = {
  threeShow?: boolean,
};
const PanelContextmenu: FC<PanelContextMenuProps> = ({ threeShow }) => {
  const ref = useRef(null);
  const panelMenu = useStore((s) => s.panelMenu);
  const clipboardElements = useStore((s) => s.clipboardElements);
  const setShowImportDSLModal = useStore((s) => s.setShowImportDSLModal);
  const { handleNodesPaste } = useNodesInteractions();
  const { nodesReadOnly } = useNodesReadOnly();
  const { handlePaneContextmenuCancel, handleNodeContextmenuCancel } =
    usePanelInteractions();
  // const { handleStartWorkflowRun } = useWorkflowStartRun();
  const { handleAddNote } = useOperator();
  const { handleExportDSL } = useDSL()
  const exportCheck = () => {
    handleExportDSL();
  };
  console.log('PanelContextmenu', threeShow);
  useEffect(() => {
    if (panelMenu) handleNodeContextmenuCancel();
  }, [panelMenu, handleNodeContextmenuCancel]);

  useClickAway(() => {
    handlePaneContextmenuCancel();
  }, ref);

  const renderTrigger = () => {
    return (
      <div
        className={cn(
          'flex h-8 cursor-pointer items-center justify-between rounded-lg px-3 text-sm text-text-secondary hover:bg-state-base-hover',
          nodesReadOnly ? 'cursor-not-allowed opacity-50' : '',
        )}
      >
        添加节点
      </div>
    );
  };

  if (!panelMenu) return null;

  return (
    <div
      className="absolute z-[9] w-[200px] rounded-lg border-[0.5px] border-components-panel-border bg-components-panel-bg-blur shadow-lg"
      style={{
        left: panelMenu.left - (threeShow ? 300 : 0),
        top: panelMenu.top,
      }}
      ref={ref}
    >
      <div className="p-1">
        <AddBlock
          renderTrigger={renderTrigger}
          offset={{
            mainAxis: -36,
            crossAxis: -4,
          }}
        />
        <div
          className={cn(
            'flex h-8 cursor-pointer items-center justify-between rounded-lg px-3 text-sm text-text-secondary hover:bg-state-base-hover',
            nodesReadOnly ? 'cursor-not-allowed opacity-50' : '',
          )}
          onClick={(e) => {
            e.stopPropagation();
            if (nodesReadOnly) return;
            handleAddNote();
            handlePaneContextmenuCancel();
          }}
        >
          添加注释
        </div>
        {/* <div
          className="flex h-8 cursor-pointer items-center justify-between rounded-lg px-3 text-sm text-text-secondary hover:bg-state-base-hover"
          onClick={() => {
            handleStartWorkflowRun();
            handlePaneContextmenuCancel();
          }}
        >
          {t('workflow.common.run')}
          <ShortcutsName keys={['alt', 'r']} />
        </div> */}
      </div>
      <Divider className="m-0 h-0" style={{ margin: 0 }} />
      <div className="p-1">
        <div
          className={cn(
            'flex h-8 cursor-pointer items-center justify-between rounded-lg px-3 text-sm text-text-secondary',
            !clipboardElements.length
              ? 'cursor-not-allowed opacity-50'
              : 'hover:bg-state-base-hover',
          )}
          onClick={() => {
            if (clipboardElements.length) {
              handleNodesPaste();
              handlePaneContextmenuCancel();
            }
          }}
        >
          粘贴到这里
          <ShortcutsName keys={['ctrl', 'v']} />
        </div>
      </div>
      <Divider className="m-0 h-0" style={{ margin: 0 }} />
      <div className="p-1">
        <div
          className="flex h-8 cursor-pointer items-center justify-between rounded-lg px-3 text-sm text-text-secondary hover:bg-state-base-hover"
          onClick={() => exportCheck()}
        >
          导出 DSL
        </div>
        <div
          className={cn(
            "flex h-8 cursor-pointer items-center justify-between rounded-lg px-3 text-sm text-text-secondary hover:bg-state-base-hover",
            nodesReadOnly ? 'cursor-not-allowed opacity-50' : '',
          )}
          onClick={() => {
            if (nodesReadOnly) return;
            setShowImportDSLModal(true);
          }}
        >
          导入 DSL
        </div>
      </div>
    </div>
  );
};

/** @name 工作流右键菜单 */
export default memo(PanelContextmenu);
